/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M20 5V14.5C20 14.8391 19.9775 15.1729 19.9339 15.5M15 11V7C15 4.23858 12.7614 2 10 2C8.87417 2 7.83526 2.37209 6.99951 3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 2L5.29737 5.29737M22 22L18.7087 18.7087M5.29737 5.29737C5.10493 5.8288 5 6.40215 5 7V14.5C5 18.6421 8.35786 22 12.5 22C15.0822 22 17.3596 20.6951 18.7087 18.7087M5.29737 5.29737L10 10M18.7087 18.7087L14.9581 14.9581M14.9581 14.9581C14.7429 16.12 13.7242 17 12.5 17C11.1193 17 10 15.8807 10 14.5V10M14.9581 14.9581L10 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M20 5V14.5C20 14.8391 19.9775 15.1729 19.9339 15.5M2 2L5.29737 5.29737M22 22L18.7087 18.7087M5.29737 5.29737C5.10493 5.8288 5 6.40215 5 7V14.5C5 18.6421 8.35786 22 12.5 22C15.0822 22 17.3596 20.6951 18.7087 18.7087M5.29737 5.29737L10 10M18.7087 18.7087L14.9581 14.9581M15 11V7C15 4.23858 12.7614 2 10 2C8.87418 2 7.83526 2.37209 6.99951 3M14.9581 14.9581C14.7429 16.12 13.7242 17 12.5 17C11.1193 17 10 15.8807 10 14.5V10M14.9581 14.9581L10 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M20 5V14.5C20 14.8391 19.9775 15.1729 19.9339 15.5M2 2L5.29737 5.29737M22 22L18.7087 18.7087M5.29737 5.29737C5.10493 5.8288 5 6.40215 5 7V14.5C5 18.6421 8.35786 22 12.5 22C15.0822 22 17.3596 20.6951 18.7087 18.7087M5.29737 5.29737L10 10M18.7087 18.7087L14.9581 14.9581M15 11V7C15 4.23858 12.7614 2 10 2C8.87418 2 7.83526 2.37209 6.99951 3M14.9581 14.9581C14.7429 16.12 13.7242 17 12.5 17C11.1193 17 10 15.8807 10 14.5V10M14.9581 14.9581L10 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M20 5V14.5C20 14.8391 19.9775 15.1729 19.9339 15.5M2 2L5.29737 5.29737M22 22L18.7087 18.7087M5.29737 5.29737C5.10493 5.8288 5 6.40215 5 7V14.5C5 18.6421 8.35786 22 12.5 22C15.0822 22 17.3596 20.6951 18.7087 18.7087M5.29737 5.29737L7.5 7.5M18.7087 18.7087L14.9581 14.9581M15 11V7C15 4.23858 12.7614 2 10 2C8.87418 2 7.83526 2.37209 6.99951 3M14.9581 14.9581C14.7429 16.12 13.7242 17 12.5 17C11.1193 17 10 15.8807 10 14.5V10L14.9581 14.9581Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M20 5V14.5C20 14.8391 19.9775 15.1729 19.9339 15.5M2 2L5.29737 5.29737M22 22L18.7087 18.7087M5.29737 5.29737C5.10493 5.8288 5 6.40215 5 7V14.5C5 18.6421 8.35786 22 12.5 22C15.0822 22 17.3596 20.6951 18.7087 18.7087M5.29737 5.29737L10 10M18.7087 18.7087L14.9581 14.9581M15 11V7C15 4.23858 12.7614 2 10 2C8.87418 2 7.83526 2.37209 6.99951 3M14.9581 14.9581C14.7429 16.12 13.7242 17 12.5 17C11.1193 17 10 15.8807 10 14.5V10M14.9581 14.9581L10 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M20 5V14.5C20 14.8391 19.9775 15.1729 19.9339 15.5M2 2L5.29737 5.29737M22 22L18.7087 18.7087M5.29737 5.29737C5.10493 5.8288 5 6.40215 5 7V14.5C5 18.6421 8.35786 22 12.5 22C15.0822 22 17.3596 20.6951 18.7087 18.7087M5.29737 5.29737L10 10M18.7087 18.7087L14.9581 14.9581M15 11V7C15 4.23858 12.7614 2 10 2C8.87418 2 7.83526 2.37209 6.99951 3M14.9581 14.9581C14.7429 16.12 13.7242 17 12.5 17C11.1193 17 10 15.8807 10 14.5V10M14.9581 14.9581L10 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
